import { Component, type ErrorInfo, type ReactNode } from "react";
import { DashboardItemContent, type DashboardItemProps } from "./DashboardItemContent";

type Props = Omit<DashboardItemProps, "error">;

interface State {
    error: boolean;
}

export class DashboardItem extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            error: false,
        };
    }

    public componentDidCatch(err: Error, errorInfo: ErrorInfo): void {
        console.error("Error caught by DashboardItem", err, errorInfo);

        this.setState({
            error: true,
        });
    }

    public render(): ReactNode {
        return (
            <DashboardItemContent
                {...this.props}
                error={this.state.error}
            />
        );
    }
}
